import { createLocalStorageHook } from '@/hooks/browser/createLocalStorageHook'
import { StationNumericSchema } from '@/business/printer-address'

export const useStationNumeric = createLocalStorageHook('station-numeric', StationNumericSchema)
